<script setup lang="ts">
// Fan of payment cards of the local and international systems
const { t } = useI18n()

const cards = [
  { name: 'Элкарт', digits: '4021', tone: 'bg-gradient-to-br from-sky-400 to-blue-600', turn: '-translate-x-16 translate-y-4 -rotate-[14deg]' },
  { name: 'Mastercard', digits: '7730', tone: 'bg-gradient-to-br from-emerald-400 to-teal-700', turn: '-translate-x-5 -rotate-[4deg]' },
  { name: 'Visa', digits: '1985', tone: 'bg-gradient-to-br from-zinc-700 to-zinc-900', turn: 'translate-x-10 -translate-y-3 rotate-[7deg]' }
]
</script>

<template>
  <div class="relative grid h-56 w-[21rem] select-none place-items-center" aria-hidden="true">
    <div
      v-for="card in cards"
      :key="card.name"
      class="absolute flex h-[8.5rem] w-[13.5rem] flex-col justify-between rounded-2xl p-4 text-white shadow-[0_24px_40px_-20px_rgba(15,23,42,0.6)]"
      :class="[card.tone, card.turn]"
    >
      <div class="flex items-start justify-between">
        <span class="h-7 w-9 rounded-md bg-gradient-to-br from-yellow-200 to-yellow-500" />
        <svg viewBox="0 0 24 24" class="size-5 opacity-80" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M8.5 7a8 8 0 0 1 0 10M12 5a11 11 0 0 1 0 14M5 9.5a4 4 0 0 1 0 5" stroke-linecap="round" />
        </svg>
      </div>
      <div class="flex items-end justify-between">
        <span class="text-sm tracking-widest opacity-90">•••• {{ card.digits }}</span>
        <span class="text-sm font-bold">{{ card.name }}</span>
      </div>
    </div>

    <div class="HeroIllustrationSticker -right-2 top-0">
      <div class="text-xs font-semibold">{{ t('widget.hero_banner.illustration.cards.cashback') }}</div>
      <div class="font-bold leading-tight">{{ t('widget.hero_banner.illustration.cards.bonuses') }}</div>
    </div>
  </div>
</template>
